import { Injectable } from '@angular/core';
import { TableEventService } from '@captiveaire/table';
import { AppRootScope } from '../../src/typings/AppRootScope';
import { EventTypes } from '../../src/typings/models';
import { SubscriptionTypes } from '../alerts/typings/SubscriptionTypes';
import { AppContextService } from '../appContext/AppContextService';
import { NotificationService } from '../notification/NotificationService';
import { CommonBroadcastService } from '@caslink/common-client/ng-app/common-broadcast/common-broadcast.service';
@Injectable({
    providedIn: 'root'
})
export class TableUpdateSubscriptionService {
    public static $name: string = 'tableUpdateSubscriptionService';

    constructor(
        private notificationService: NotificationService,
        private appContextService: AppContextService,
        private tableEventService: TableEventService,
        private commonBroadcastService: CommonBroadcastService,
    ) { }

    public subscribe(
        subscription: SubscriptionTypes,
        eventType: EventTypes,
        criteria: any,
        scope?: AppRootScope
    ) {
        this.notificationService.startUpdates(this.appContextService.loadedLocationId, subscription, criteria, null);

        if (scope) {
            scope.subscribe(eventType, () => {
                this.tableEventService.updateAndNotifyEvent.emit();
            });
        } else {
            this.commonBroadcastService.on(eventType).subscribe(() => {
                this.tableEventService.updateAndNotifyEvent.emit();
            });
        }
    }

    public unsubscribe(subscription: SubscriptionTypes, criteria: any) {
        this.notificationService.stopUpdates(this.appContextService.loadedLocationId, subscription, criteria);
    }
}
